export const InitSurveyCreatorConfig = () => {
  console.log("Initializing Survey Creator Config");
  if (appConfig.surveyJsKey) {
    window.Survey.slk(appConfig.surveyJsKey);
  }
  initLocales();
  createSurveyAuccaCustomQuestionType();
};

const initLocales = () => {
  window.SurveyCreatorCore.getLocaleStrings("en").qt.text = "Single Line Answer";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.comment = "Long Text Response";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.multipletext = "Multiple Text Fields";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.radiogroup = "Single Choice";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.checkbox = "Multi Choice";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.rating = "Rating";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.dropdown = "Single Choice Dropdown";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.tagbox = "Multi Choice Dropdown";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.panel = "Section";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.matrix = "Single Choice Matrix";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.matrixdropdown = "Multi Choice Matrix";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.ranking = "Ranking";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.slider = "Slider";
};

const createSurveyAuccaCustomQuestionType = () => {
  const componentCollection = window.Survey.ComponentCollection.Instance;
  const readinessSvg = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg">
<path d="M8.30769 18.8071C8.13837 18.6783 8.01423 18.5144 7.93528 18.3156L5.44739 12.1106H0V10.9125H6.29832L8.87849 17.4379L14.1317 4.68445C14.2103 4.48555 14.3335 4.3217 14.5014 4.1929C14.6693 4.0643 14.8597 4 15.0725 4C15.2855 4 15.4767 4.0643 15.646 4.1929C15.8153 4.3217 15.9395 4.48555 16.0184 4.68445L18.5526 10.9125H24V12.1106H17.7017L15.0752 5.5621L9.82201 18.3156C9.74346 18.5144 9.62022 18.6783 9.4523 18.8071C9.28437 18.9357 9.09401 19 8.8812 19C8.66819 19 8.47702 18.9357 8.30769 18.8071Z" fill="inherit"/>
</svg>
`;

  window.Survey.SvgRegistry.registerIcon("icon-aucca", readinessSvg);
  componentCollection.add({
    name: "aucca",
    title: "Readiness Question",
    iconName: "icon-aucca",
    defaultQuestionTitle: "Readiness Question",
    questionJSON: {
      type: "radiogroup",
      placeholder: "Select a AUCCA...",
      choices: [
        { value: 5, text: "Strongly Agree" },
        { value: 4, text: "Agree" },
        { value: 3, text: "Neutral" },
        { value: 2, text: "Disagree" },
        { value: 1, text: "Strongly Disagree" }
      ]
    },
    inheritBaseProps: ["type", "placeholder", "choices"],
    onInit() {
      window.Survey.Serializer.addProperty("aucca", {
        name: "aucca",
        displayName: "AUCCA",
        category: "general",
        type: "multiplevalues",
        choices: ["Awareness", "Understanding", "Commit", "Acquire", "Apply"],
        visible: true
      });
    }
  });
};
